"use strict";
import Vue from 'vue'
import axios from "axios";

function getToken() {
  const token = window.localStorage.getItem('access_token');
  return token
}

axios.defaults.headers.common = { 'Authorization': `Bearer ${getToken()}` }

export default axios.create({
  baseURL: Vue.config.devtools
    ? "https://localhost:3000/"
    : "https://www.tgschwalbach.de/",
  rejectUnauthorized: Vue.config.devtools ? false : true,
  withCredentials: true,
});
